// components/providers/SessionModalProvider.js - Global session modal management
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SessionWarningModal from '../../features/auth/components/modals/SessionWarningModal';

const SessionModalProvider = ({ children }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [minutesRemaining, setMinutesRemaining] = useState(0);
  const [warningHandlers, setWarningHandlers] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    // Listen for session warning events
    const handleSessionWarning = (event) => {
      setMinutesRemaining(event.detail.minutesRemaining);
      setWarningHandlers({
        onExtend: event.detail.onExtend,
        onLogout: event.detail.onLogout
      });
      setShowWarning(true);
    };

    // Listen for session extended (hide warning)
    const handleSessionExtended = () => {
      setShowWarning(false);
    };

    // Listen for session expired
    const handleSessionExpired = () => {
      setShowWarning(false);
      // Navigate to login
      navigate('/', { replace: true });
    };

    // Listen for expiry message
    const handleSessionExpiredMessage = () => {
      // Simple alert for now - could be replaced with a nicer modal
      setTimeout(() => {
        // eslint-disable-next-line no-alert
        alert('Your session has expired due to inactivity. Please log in again.');
      }, 100);
    };

    window.addEventListener('sessionWarning', handleSessionWarning);
    window.addEventListener('sessionExtended', handleSessionExtended);
    window.addEventListener('sessionExpired', handleSessionExpired);
    window.addEventListener('sessionExpiredMessage', handleSessionExpiredMessage);

    return () => {
      window.removeEventListener('sessionWarning', handleSessionWarning);
      window.removeEventListener('sessionExtended', handleSessionExtended);
      window.removeEventListener('sessionExpired', handleSessionExpired);
      window.removeEventListener('sessionExpiredMessage', handleSessionExpiredMessage);
    };
  }, [navigate]);

  const handleExtendSession = () => {
    if (warningHandlers.onExtend) {
      warningHandlers.onExtend();
    }
    setShowWarning(false);
  };

  const handleLogout = () => {
    if (warningHandlers.onLogout) {
      warningHandlers.onLogout();
    }
    setShowWarning(false);
  };

  return (
    <>
      {children}
      <SessionWarningModal
        isOpen={showWarning}
        minutesRemaining={minutesRemaining}
        onExtend={handleExtendSession}
        onLogout={handleLogout}
      />
    </>
  );
};

export default SessionModalProvider;